module.exports = __webpack_public_path__ + "img/event_bg.41957ef1.png";